export const Logo = (props: any) => {
  if (props.src) {
    return (
      <img
        src={props.src}
        alt={props.alt || "logo"}
        width={props.size}
        height={props.size}
        style={{
          display: "block",
          borderRadius: props.radius || "9999px",
          objectFit: "cover",
        }}
      />
    );
  }

  return (
    <svg
      width={props.size}
      height={props.size}
      viewBox="0 0 43 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.619141" y="0.555664" width="42" height="42" rx="21" fill={props.outerColor} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99153 17.3493L6.42969 18.9111L15.8007 28.2822C19.251 31.7325 24.8451 31.7325 28.2954 28.2822L17.3626 17.3493C14.7748 14.7616 10.5793 14.7616 7.99153 17.3493ZM25.1717 18.9111L23.6099 20.4729L29.8573 26.7203C29.8573 26.7203 33.2531 24.0183 34.7959 21.7628C35.5793 20.6174 36.5215 18.6567 36.5215 18.6567C35.2736 18.8171 34.0567 18.317 32.9434 17.7308C30.4421 16.4139 27.2756 16.8073 25.1717 18.9111Z"
        fill={props.innerColor}
      />
    </svg>
  );
};

export const LogoText = (props: any) => {
  if (props.text) {
    return (
      <span
        style={{
          color: props.color,
          fontSize: props.size,
          fontWeight: 700,
          lineHeight: 1,
          whiteSpace: "nowrap",
        }}
      >
        {props.text}
      </span>
    );
  }

  return (
    <svg
      width={props.size}
      height={props.size}
      viewBox="0 0 51 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_9408_5647)">
        <path
          d="M18.7345 35.7642H7.24512C5.36481 35.7642 3.81417 35.0805 2.59319 33.7129C1.37221 32.3454 0.761719 30.6848 0.761719 28.7312V12.4307H1.55469C5.04133 12.4307 7.86782 15.2572 7.86782 18.744V25.7641C7.86782 27.0828 7.97771 27.9497 8.19748 28.3649C8.44168 28.78 9.02775 28.9876 9.95569 28.9876H13.4779C14.1223 28.9876 14.6583 29.4961 14.78 30.1289C14.9353 30.9368 15.2482 32.0388 15.8728 32.9757C17.0175 34.6928 18.7345 35.7642 18.7345 35.7642Z"
          fill={props.color}
        />
        <path
          d="M27.749 29.2807V35.7642L25.5512 35.9108C23.0604 35.9108 21.0214 35.1415 19.4341 33.603C17.8468 32.0401 17.0532 29.9522 17.0532 27.3392C17.0532 24.6042 17.9445 22.4552 19.7272 20.8923C21.3877 19.4515 23.561 18.7311 26.2472 18.7311C29.202 18.7311 31.5462 19.7445 33.28 21.7714C34.8429 23.6029 35.6243 25.7519 35.6243 28.2184V35.7642H28.8112V27.3392C28.8112 26.5822 28.5548 25.9961 28.042 25.581C27.5536 25.1658 26.9553 24.9583 26.2472 24.9583C25.6123 24.9583 25.0384 25.1414 24.5256 25.5077C24.0372 25.874 23.793 26.3991 23.793 27.0828C23.793 27.9131 23.9884 28.5725 24.3791 29.0609C24.7942 29.5493 25.3314 29.7935 25.9908 29.7935C26.5524 29.7935 27.1385 29.6225 27.749 29.2807Z"
          fill={props.color}
        />
        <path
          d="M36.0275 39.1983C36.0275 39.1983 37.4232 39.0494 38.3169 35.7642C40.0066 29.5527 37.1722 21.2342 37.1722 19.2806C37.1722 17.3269 37.9048 15.703 39.37 14.4087C40.8596 13.09 42.8376 12.4307 45.3039 12.4307H50.7617V19.0241H47.172C46.0976 19.0241 45.3772 19.2073 45.0109 19.5736C44.9132 19.6957 44.8278 19.8666 44.7545 20.0864C44.608 20.5016 44.5347 21.0144 44.5347 21.6249H50.7617V27.7055H44.5347C44.5347 27.7055 45.1377 32.6616 44.5347 35.7413C44.066 38.1352 42.1596 39.1983 39.7203 39.1983H36.0275Z"
          fill={props.color}
        />
      </g>
      <defs>
        <clipPath id="clip0_9408_5647">
          <rect width="50" height="50" fill="white" transform="translate(0.761719 0.555664)" />
        </clipPath>
      </defs>
    </svg>
  );
};
